import React, { useEffect } from 'react';
import { useRouteTracker } from '@shared/Hooks/Auth/useRouteTracker';
import { useHostEmailWatcher } from '@shared/Hooks/Auth/UseHostEmailWatcher/UseHostEmailWatcher';
import { useRestoreLastRoute } from '@shared/Hooks/Auth/useRestoreRoutre';
import { useAuthorizationViewModel } from '@viewModels/AuthorizationViewModel/AuthorizationViewModel';

const SessionPolicy: React.FC<{ children: React.ReactNode }> = ({
    children,
}) => {
    const { getToken } = useAuthorizationViewModel();

    useEffect(() => {
        getToken();
    }, []);

    useRouteTracker();
    useHostEmailWatcher();
    useRestoreLastRoute();

    return <>{children}</>;
};

export default SessionPolicy;
